// 国产吃瓜 · 单页热点快讯站 mock 数据

export interface NewsItem {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  time: string;
  image: string;
  tag: string;
  views: string;
  likes: number;
  area: string;
}

export interface SceneItem {
  id: number;
  place: string;
  date: string;
  title: string;
  excerpt: string;
  image: string;
  tag: string;
}

export interface TrendTopic {
  id: number;
  rank: number;
  title: string;
  heat: string;
  delta: string;
  up: boolean;
}

export interface FaqItem {
  q: string;
  a: string;
}

const IMG_HERO =
  "https://readdy.ai/api/search-image?query=Warm%20evening%20city%20night%20market%20in%20China%2C%20string%20lights%20glowing%20over%20food%20stalls%2C%20young%20people%20walking%20and%20chatting%2C%20lively%20street%20atmosphere%2C%20coral%20and%20amber%20tonal%20grading%2C%20editorial%20documentary%20photography%2C%20soft%20warm%20highlights%2C%20cinematic%20depth%2C%20no%20text&width=1600&height=720&seq=gua-hero-x1&orientation=landscape";

const IMG_N1 =
  "https://readdy.ai/api/search-image?query=Colorful%20theatrical%20stage%20with%20young%20performers%20under%20spotlights%2C%20glowing%20concert%20lights%20in%20warm%20orange%20and%20cream%2C%20crowd%20silhouettes%20cheering%2C%20editorial%20magazine%20photography%2C%20high%20energy%2C%20clean%20composition%2C%20no%20text&width=720&height=480&seq=gua-n1-x2&orientation=landscape";

const IMG_N2 =
  "https://readdy.ai/api/search-image?query=Hands%20holding%20a%20glowing%20autumn%20osmanthus%20milk%20tea%20cup%20near%20falling%20golden%20leaves%2C%20cozy%20autumn%20cafe%20scene%2C%20warm%20amber%20tones%2C%20soft%20natural%20light%2C%20editorial%20food%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=720&height=480&seq=gua-n2-x3&orientation=landscape";

const IMG_N3 =
  "https://readdy.ai/api/search-image?query=Renovated%20historic%20old%20street%20in%20a%20small%20Chinese%20town%2C%20young%20people%20strolling%20past%20boutique%20shops%2C%20warm%20evening%20glow%2C%20traditional%20architecture%20with%20modern%20storefronts%2C%20editorial%20documentary%20photography%2C%20cream%20and%20coral%20palette%2C%20no%20text&width=720&height=480&seq=gua-n3-x4&orientation=landscape";

const IMG_N4 =
  "https://readdy.ai/api/search-image?query=Creamy%20tomato%20egg%20dish%20plated%20with%20creative%20modern%20twist%20on%20a%20cafeteria%20tray%2C%20bright%20fresh%20college%20canteen%2C%20warm%20appetizing%20light%2C%20editorial%20food%20photography%2C%20clean%20minimal%20background%2C%20no%20text&width=720&height=480&seq=gua-n4-x5&orientation=landscape";

const IMG_N5 =
  "https://readdy.ai/api/search-image?query=People%20riding%20bicycles%20along%20a%20tree%20lined%20city%20commute%20path%20at%20morning%2C%20golden%20sunlight%20through%20leaves%2C%20city%20skyline%20behind%2C%20fresh%20urban%20lifestyle%2C%20editorial%20photography%2C%20warm%20tone%2C%20motion%20and%20energy%2C%20no%20text&width=720&height=480&seq=gua-n5-x6&orientation=landscape";

const IMG_N6 =
  "https://readdy.ai/api/search-image?query=Young%20artisan%20in%20modern%20studio%20performing%20traditional%20Chinese%20craft%20weaving%2C%20hand%20closeup%2C%20warm%20workshop%20light%2C%20intangible%20cultural%20heritage%20revival%2C%20editorial%20documentary%20photography%2C%20coral%20and%20wood%20tones%2C%20no%20text&width=720&height=480&seq=gua-n6-x7&orientation=landscape";

const IMG_N7 =
  "https://readdy.ai/api/search-image?query=Cute%20fluffy%20dog%20walking%20with%20owner%20in%20a%20sunny%20residential%20community%20park%2C%20neighbors%20chatting%20while%20walking%20pets%2C%20warm%20afternoon%20light%2C%20pet%20lifestyle%20trend%2C%20editorial%20photography%2C%20soft%20cream%20background%2C%20no%20text&width=720&height=480&seq=gua-n7-x8&orientation=landscape";

const IMG_N8 =
  "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20stage%20at%20dusk%20in%20a%20small%20city%20park%2C%20vibrant%20warm%20stage%20lights%2C%20crowd%20enjoying%20concert%2C%20night%20economy%20vibe%2C%20editorial%20photography%2C%20coral%20and%20amber%20palette%2C%20no%20text&width=720&height=480&seq=gua-n8-x9&orientation=landscape";

const IMG_S1 =
  "https://readdy.ai/api/search-image?query=Autumn%20open%20air%20artisan%20market%20in%20an%20art%20district%2C%20wooden%20stalls%20with%20handmade%20goods%20and%20warm%20lanterns%2C%20people%20browsing%20at%20dusk%2C%20editorial%20documentary%20photography%2C%20warm%20cream%20and%20amber%20tones%2C%20no%20text&width=900&height=600&seq=gua-s1-x10&orientation=landscape";

const IMG_S2 =
  "https://readdy.ai/api/search-image?query=Visitors%20hands%20on%20learning%20traditional%20paper%20cutting%20and%20pottery%20in%20a%20bright%20culture%20park%20workshop%2C%20warm%20natural%20light%2C%20craft%20heritage%20experience%20event%2C%20editorial%20photography%2C%20no%20text&width=900&height=600&seq=gua-s2-x11&orientation=landscape";

const IMG_S3 =
  "https://readdy.ai/api/search-image?query=Group%20of%20runners%20and%20cyclists%20along%20a%20riverside%20greenway%20at%20sunset%2C%20city%20skyline%20across%20the%20water%2C%20warm%20golden%20hour%20light%2C%20active%20urban%20night%20routine%2C%20editorial%20photography%2C%20coral%20and%20cream%20palette%2C%20no%20text&width=900&height=600&seq=gua-s3-x12&orientation=landscape";

export const newsItems: NewsItem[] = [
  {
    id: 1,
    title: "综艺舞台名场面刷屏：这段即兴表演被反复考古",
    category: "娱乐现场",
    excerpt:
      "一段不到三分钟的舞台即兴近期在社交平台反复被考古，网友笑称“每次点开都能发现新的细节”。无论是编排节奏还是现场反应，都成了大家下班后最常聊的话题。",
    time: "26分钟前",
    image: IMG_N1,
    tag: "热度飙升",
    views: "12.6万",
    likes: 3480,
    area: "综艺现场",
  },
  {
    id: 2,
    title: "桂花季来了，城市里的“秋天第一杯”纷纷上新",
    category: "消费观察",
    excerpt:
      "桂花陆续盛开，饮品店与甜品铺抢先上新。桂花拿铁、桂花酒酿、桂花栗子蛋糕，价格从十几元到几十元不等，年轻消费者愿为“季节限定”买单，商家也靠秋味带动了一波客流。",
    time: "1小时前",
    image: IMG_N2,
    tag: "应季热品",
    views: "9.3万",
    likes: 2510,
    area: "城市消费",
  },
  {
    id: 3,
    title: "老街区改造焕新：年轻人开始回小城“找生活”",
    category: "城市新鲜事",
    excerpt:
      "一批历史老街经过渐进式改造后重新聚拢人气。独立咖啡馆、手作工作室与旧书店相继入驻，房租与节奏相对友好，让不少年轻人把“回小城生活”从念头变成了选择。",
    time: "2小时前",
    image: IMG_N3,
    tag: "热门话题",
    views: "8.1万",
    likes: 1987,
    area: "城市观察",
  },
  {
    id: 4,
    title: "高校食堂创意菜走红：番茄炒蛋也有“新皮肤”",
    category: "民生趣闻",
    excerpt:
      "从“网红窗口”到“地方美食周”，高校食堂越来越会整活儿。一份创意番茄炒蛋、一碗限定口味的早餐，都能成为学生社交平台的流量担当，也让校园生活多了几分烟火气。",
    time: "3小时前",
    image: IMG_N4,
    tag: "校园趣闻",
    views: "6.7万",
    likes: 1672,
    area: "校园生活",
  },
  {
    id: 5,
    title: "骑行通勤升温：早高峰多了一群“追风”的人",
    category: "出行生活",
    excerpt:
      "随着绿道与停放设施不断完善，骑行正成为不少城市居民的日常通勤方式。避开拥堵、顺带锻炼，骑行族把上班路变成了一天的第一段“放空时间”。",
    time: "4小时前",
    image: IMG_N5,
    tag: "生活方式",
    views: "7.9万",
    likes: 2204,
    area: "出行观察",
  },
  {
    id: 6,
    title: "非遗技艺登上舞台，年轻人追起了“国潮现场”",
    category: "娱乐现场",
    excerpt:
      "当传统手作遇上当代舞台与新媒体，一批非遗技艺以更年轻的表达走进大众视野。看展、体验、二次创作，年轻人正用自己的方式让老手艺被更多人看见。",
    time: "5小时前",
    image: IMG_N6,
    tag: "国潮现场",
    views: "11.2万",
    likes: 3055,
    area: "文化现场",
  },
  {
    id: 7,
    title: "宠物经济再升温，“遛狗搭子”成了小区新社交",
    category: "民生趣闻",
    excerpt:
      "从宠物寄养、上门喂养到同小区“遛狗搭子”，围绕宠物的服务与社交正在社区里自然生长。不少人笑称，因为宠物认识了邻居，社交半径也跟着变大了。",
    time: "6小时前",
    image: IMG_N7,
    tag: "生活趋势",
    views: "5.4万",
    likes: 1430,
    area: "社区观察",
  },
  {
    id: 8,
    title: "音乐节开到小城，文旅“夜经济”迎来高光时刻",
    category: "城市新鲜事",
    excerpt:
      "越来越多音乐节、市集与演出选择下沉到二三线城市。本地特色搭配年轻内容，既带火了周边住宿餐饮，也让小城的夜晚多了新的打开方式。",
    time: "今天 08:12",
    image: IMG_N8,
    tag: "文旅热点",
    views: "15.8万",
    likes: 4120,
    area: "文旅一线",
  },
];

export const sceneItems: SceneItem[] = [
  {
    id: 1,
    place: "城东艺术区 · 秋日市集",
    date: "09.06 现场",
    title: "秋日市集开摊：一杯热饮、一份手作，治愈了整个周末",
    excerpt:
      "黄昏时分，城东艺术区的市集陆续亮灯。手作摊主与往来食客在桂花香气里闲聊，不少摊主表示客流超出预期，几乎每个摊位前都排起了队。",
    image: IMG_S1,
    tag: "现场直击",
  },
  {
    id: 2,
    place: "城南文创园 · 非遗体验",
    date: "09.07 现场",
    title: "非遗体验课场场爆满，老手艺正在被年轻人“温柔接住”",
    excerpt:
      "剪纸、陶艺、木作体验课近期几乎满座。带队老师介绍，课程更强调“边做边讲”，参与者既能带走作品，也能听懂背后的故事。",
    image: IMG_S2,
    tag: "现场直击",
  },
  {
    id: 3,
    place: "滨江绿道 · 夜跑夜骑",
    date: "09.05 现场",
    title: "日落后的滨江绿道人潮涌动：夜跑夜骑成了新的城市默契",
    excerpt:
      "暑气退去后的傍晚，滨江绿道迎来一天中最热闹的时段。骑行、夜跑与散步人群各得其所，沿途补给点也自发形成，秩序井然。",
    image: IMG_S3,
    tag: "现场直击",
  },
];

export const trendTopics: TrendTopic[] = [
  { id: 1, rank: 1, title: "这届年轻人开始给生活“做减法”", heat: "192.6万", delta: "上升 12", up: true },
  { id: 2, rank: 2, title: "小城文旅出圈，下一个打卡地在哪里", heat: "168.4万", delta: "上升 9", up: true },
  { id: 3, rank: 3, title: "AI 走进课堂，老师的备课方式悄悄变了", heat: "145.2万", delta: "上升 6", up: true },
  { id: 4, rank: 4, title: "“县城咖啡”成为新的消费风向", heat: "121.7万", delta: "上升 15", up: true },
  { id: 5, rank: 5, title: "秋日夜间经济：市集正在霸屏社交平台", heat: "98.3万", delta: "下降 3", up: false },
  { id: 6, rank: 6, title: "非遗加国潮，老手艺有了新的表达方式", heat: "86.9万", delta: "上升 8", up: true },
  { id: 7, rank: 7, title: "开学季观察：通勤与热爱如何平衡", heat: "64.1万", delta: "下降 2", up: false },
  { id: 8, rank: 8, title: "共享出行新规落地，通勤族留意了吗", heat: "52.7万", delta: "上升 5", up: true },
];

export const categoryList = ["全部", "娱乐现场", "城市新鲜事", "消费观察", "民生趣闻", "出行生活"];

export const faqItems: FaqItem[] = [
  {
    q: "瓜场是什么？资讯多久更新一次？",
    a: "瓜场是面向中文读者的热点快讯聚合站点，聚焦娱乐现场、城市新鲜事、消费观察、民生趣闻与出行生活等内容。编辑部全天滚动更新，第一时间把今天大家在聊什么、现场发生了什么整理给大家，方便随手翻看，不错过热闹。",
  },
  {
    q: "你们会涉及个人隐私或侵权内容吗？",
    a: "不会。瓜场坚持“理性吃瓜”的原则：不追踪个人隐私、不传播未经核实的私生活信息，涉及具体人物或事件时均以公开可查的信息源为准，并对争议内容做必要说明，从源头把关。",
  },
  {
    q: "信息可信吗？如何核实的？",
    a: "瓜场会优先采用一手或权威二手信源，并对每条资讯标注发布时间与地域归属。对于无法确认或仍在发酵的事件，会明确标注“跟进中”而非直接下结论。欢迎读者就疑点反馈，我们会复查更正。",
  },
  {
    q: "有线索或选题想投稿，应该怎么联系？",
    a: "如果你身边有值得一聊的城市新鲜事或现场见闻，欢迎整理成简要文字发到官方邮箱 guachang@example.com，注明事件发生的时间、地点与可公开的信源。采纳前我们会与你确认细节并标明线索来源。",
  },
  {
    q: "浏览瓜场收费吗？",
    a: "完全免费。瓜场的资讯、热点榜与专题内容均对读者开放浏览，无需注册、无需付费。你只需随手点开，就能快速掌握今天的热点动向。",
  },
  {
    q: "可以转载或分享瓜场的内容吗？",
    a: "欢迎在社交平台分享原文链接；如需转载文字或图片，请注明出处“瓜场”并保留原文链接，方便读者追溯与核实。禁止将内容用于任何误导性或商业性质的非授权用途。",
  },
];

export const categoryStats: { label: string; value: string; role: "primary" | "accent" | "secondary" }[] = [
  { label: "每日更新条数", value: "200+", role: "primary" },
  { label: "覆盖城市现场", value: "60+", role: "accent" },
  { label: "读者月访问", value: "800w+", role: "secondary" },
  { label: "信源平均核实", value: "2.5", role: "accent" },
];

export const testimonials: { quote: string; name: string; role: string }[] = [
  { quote: "通勤路上刷一遍今天的瓜，感觉整个上午都跟得上大家在聊什么了，信息很清爽。", name: "林晓", role: "通勤族 · 杭州" },
  { quote: "做内容选题时参考瓜场整理的城市现场，靠谱且选题角度很接地气。", name: "阿澈", role: "自媒体创作者" },
  { quote: "喜欢它“理性吃瓜”的原则，不标题党、不堆隐私，读起来舒服又安心。", name: "小满", role: "大学生 · 成都" },
];

export const heroHeadlines: { title: string; tag: string }[] = [
  { title: "音乐节下沉小城，夜经济迎来高光时刻", tag: "文旅热点" },
  { title: "非遗体验课场场满座，老手艺被温柔接住", tag: "文化现场" },
  { title: "桂花上新季，城市的秋天第一杯开卷了", tag: "消费观察" },
  { title: "骑行通勤升温，早高峰多了追风的人", tag: "出行生活" },
  { title: "综艺舞台即兴名场面，被网友反复考古", tag: "娱乐现场" },
];

export const liveFeeds: string[] = [
  "滨江绿道夜跑夜骑人气旺，补给点自发形成",
  "老字号桂花栗子糕今日售罄，明日补货",
  "城东艺术区周末市集增开夜市时段",
  "非遗木作体验课国庆名额已开放预约",
  "县域共享单车新规落地，通勤族留意计费变化",
  "高校食堂推出“家乡味”窗口，学生排长队打卡",
];